export default "__VITE_ASSET__DmpeIGfl__"